import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { stagger, fadeUp, viewportOnce } from "@/lib/motion";
import { ArrowUpRight } from "lucide-react";
import { JOURNAL } from "@/data/content";

const Journal = () => {
  return (
    <section
      id="journal"
      data-testid="journal-section"
      className="relative bg-ivory py-28 md:py-40 scroll-mt-24"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-24">
          <div className="max-w-2xl">
            <Reveal>
              <p className="kicker text-gold mb-6">The Journal</p>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="font-serif font-light text-charcoal text-4xl md:text-6xl leading-[1.05] tracking-tight">
                Notes on sound, ritual and slower living.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.12}>
            <span className="kicker text-forest border-b border-forest/30 pb-1">
              Full journal — coming soon
            </span>
          </Reveal>
        </div>

        <motion.div
          variants={stagger(0.08, 0.14)}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12"
        >
          {JOURNAL.map((post, i) => (
            <motion.article
              key={i}
              variants={fadeUp}
              data-testid={`journal-card-${i}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-[4/5] mb-6">
                <img
                  src={post.image}
                  alt={post.title}
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-forest/10 group-hover:bg-forest/0 transition-colors duration-700" aria-hidden="true" />
                <span className="absolute top-4 left-4 bg-ivory/90 backdrop-blur-sm px-3 py-1 kicker text-forest text-[0.55rem]">
                  {post.tag}
                </span>
              </div>
              <div className="flex items-start justify-between gap-4">
                <h3 className="font-serif font-light text-charcoal text-2xl md:text-3xl leading-snug group-hover:text-forest transition-colors duration-400">
                  {post.title}
                </h3>
                <ArrowUpRight
                  size={22}
                  strokeWidth={1.4}
                  className="mt-1 shrink-0 text-charcoal/40 transition-all duration-400 group-hover:text-gold group-hover:-translate-y-1 group-hover:translate-x-1"
                />
              </div>
              <p className="mt-3 text-charcoal/65 leading-relaxed">{post.excerpt}</p>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Journal;
